<template>
  <div class="m-wap-content" v-html="content" ref="contentContainer"></div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import { videoProtectionMixin } from "../../mixin/videoProtection";

export default {
  name: "WapContent",
  mixins: [videoProtectionMixin],
  data() {
    return {
      content: "",
      title: "",
      pushTime: "",
      likeCount: "",
      browseCount: "",
      commentCount: "",
      isAllowedComment: "",
      isAllowedLike: false,
      //      isAllowedLike: true,
      //      likeCount: 0,
      canLike: false,
      schemaId: "",
      isSubmitting: false
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.content = info.content;
        this.title = info.title;
        this.pushTime = info.pushTime;
        this.likeCount = info.likeCount;
        this.browseCount = info.statInfo.browseCount;
        this.isAllowedComment = info.isAllowedComment == 1;
        this.isAllowedLike = info.isAllowedLike == 1;
        // 内容更新后处理video标签
        this.handleContentUpdate();
      }
      $subscriber.subscribe("comment-count", info => {
        this.commentCount = info;
      });
      $subscriber.subscribe("like-count", info => {
        this.likeCount = info;
      });
    });
  },
  components: {}
};
</script>
